<template>
    <div id="student-status" class="card mb-3">
        <div class="card-body">
            <h5 class="card-title"><i class="fas fa-hands-helping"></i> Check-In Status</h5>
            <div class="card-text">
                Academic Counsellor Information
            </div>
        </div>
        <div class="d-flex align-items-end flex-column my-3 mx-3">
            <!-- Button trigger modal -->
            <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#cancelAppointment">
                Cancel Appointment
            </button>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="cancelAppointment" tabindex="-1" aria-labelledby="cancelAppointmentLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="cancelAppointmentLabel">Cancel Appointment Confirmation</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="reset()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="alert.status == 'success'" class="alert alert-success" role="alert">
                            <i class="fas fa-check"></i> {{ alert.message }}
                        </div>
                        <div v-else-if="alert.status == 'warning'" class="alert alert-warning" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ alert.message }}
                        </div>
                        <div v-else-if="alert.status == 'error'" class="alert alert-danger" role="alert">
                            <i class="fas fa-exclamation-triangle"></i> {{ alert.message }}
                        </div>
                        <div v-if="!valid" class="alert alert-danger" role="alert">
                            <i class="fas fa-exclamation-circle"></i> The cancellation could not be completed. Please
                            verify that all required form
                            fields are filled in.
                        </div>
                        <p>
                            Are you sure you want to cancel your academic counselling appointment? This action cannot be
                            undone! Please select a reason for the cancellation and click comfirm to proceed.
                        </p>
                        <div class="form-group">
                            <label for="cancellationReason" class="font-weight-bold">Cancellation Reason</label>
                            <select v-model="cancellationReason" class="form-control" id="cancellationReason">
                                <option>Have to go to class</option>
                                <option>I've resolved my issue</option>
                                <option>Wait time too long</option>
                                <option>Other</option>
                            </select>
                        </div>
                        <div v-if="cancellationReason == 'Other'" class="form-group">
                            <label for="cancellationReasonOther" class="font-weight-bold">Other</label>
                            <textarea v-model="cancellationReasonOther"
                                :class="cancellationReasonOtherValid == true ? 'form-control' : 'form-control is-invalid'"
                                id="cancellationReasonOther" rows="3"
                                placeholder="Please provide a reason for the cancellation"></textarea>
                            <div v-if="!cancellationReasonOtherValid" class="invalid-feedback">
                                Please provide a valid reason for the cancellation.
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="submit" type="button" class="btn btn-success" disabled>Submitting <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-success" @click="submitForm()">Confirm</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// const DEPARTMENT = `Academic Dean's Office`;
import $ from 'jquery';

export default {
    name: 'student-status',
    props: {
        assignedCounsellor: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            alert: {
                message: '',
                status: ''
            },
            cancellationReason: 'Have to go to class',
            cancellationReasonOther: '',
            cancellationReasonOtherValid: true,
            submit: false,
            valid: true
        }
    },
    methods: {
        reset() {
            // Reset form validation and values
            this.alert = {
                message: '',
                status: ''
            };
            this.cancellationReason = 'Have to go to class';
            this.cancellationReasonOther = '';
            this.cancellationReasonOtherValid = true;
            this.valid = true;
        },
        submitForm() {
            if (this.validateForm()) {
                const that = this;
                const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl`;
                const formData = new FormData();

                // Add form keypair values
                // formData.append('department', DEPARTMENT);
                formData.append('cancellationReason', this.cancellationReason);
                formData.append('cancellationReasonOther', this.cancellationReasonOther);
                formData.append('mode', 'selfCancel');

                // Set default keys
                this.alert = {
                    message: '',
                    status: ''
                };
                this.submit = true;

                // POST request
                fetch(api, {
                    method: 'POST',
                    body: formData
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.alert.message = `You cancellation request has been completed. Please wait to be redirected...`;
                        that.alert.status = 'success';
                        that.$emit('refreshData');
                        $('#cancelAppointment').modal('hide');
                    } else if (json.result.match(/^WARNING/i)) {
                        that.alert.message = `${json.message}. Please contact your system administrator.`;
                        that.alert.status = 'warning';
                    } else {
                        that.alert.message = `An error has occurred. Please contact your system administrator.`;
                        that.alert.status = 'error';
                    }

                    that.submit = false;
                }).catch(function () {
                    that.alert.message = `An error has occurred. Please contact your system administrator.`;
                    that.alert.status = 'error';
                    that.submit = false;
                })
            }
        },
        validateForm() {
            // Validate cancellation request
            if (this.cancellationReason == "Other") {
                this.cancellationReasonOtherValid = this.cancellationReasonOther && this.cancellationReasonOther.length >= 2 ? true : false;
            } else {
                this.cancellationReasonOtherValid = true;
            }

            // Validate form
            if (!this.cancellationReasonOtherValid) {
                this.valid = false;
            } else {
                this.valid = true;
            }

            return this.valid;
        }
    }
}
</script>